/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Task_Status_OpenInputs */

const en_attribute_task_status_open = /** @type {(inputs: Attribute_Task_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not started`)
};

/**
* | output |
* | --- |
* | "Not started" |
*
* @param {Attribute_Task_Status_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_task_status_open = /** @type {((inputs?: Attribute_Task_Status_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Task_Status_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_task_status_open(inputs)
});